import createFlexContainer from './helpers/createFlexContainer';

var defaultRowStyle = { flexDirection: 'row', justifyContent: 'space-between' };

export default createFlexContainer(defaultRowStyle, 'Row');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dhis2/d2-ui-app/node_modules/@dhis2/d2-ui-core/build/es/layout/Row.component.js
// module id = 1978
// module chunks = 0